import { io, type Socket } from "socket.io-client";

import { getApiBaseUrl } from "./apiBaseUrl";

let socket: Socket | null = null;

/**
 * Get or create the singleton socket instance.
 * Does NOT auto-connect — call connect() explicitly.
 */
export function getSocket(): Socket {
  if (!socket) {
    socket = io(getApiBaseUrl(), {
      autoConnect: false,
      withCredentials: true,
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 30000,
      randomizationFactor: 0.5,
    });
  }
  return socket;
}

/**
 * Connect the socket (auth handled via cookies).
 */
export function connectSocket(): void {
  const s = getSocket();
  if (!s.connected) {
    s.connect();
  }
}

/**
 * Disconnect and clean up the socket.
 */
export function disconnectSocket(): void {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
